module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"write_caption":"キャプションを書く…"}}')
  delete Component.options._Ctor
}
